import { JSON_PATH_ROOT } from './constants';
var unwrap = function (_a) {
    var responseMessageResultPath = _a.responseMessageResultPath;
    return "$.".concat(responseMessageResultPath);
};
var transformations = {
    JS_SINGLE_ARG_UNCHANGED: '$[0]',
    RESPONSE_OBJECT_UNCHANGED: JSON_PATH_ROOT,
    ARRAY_ITEMS_PATH_PROPERTY_NAME: '@path',
    ARRAY_ITEM_TRANSFORMATION_PROPERTY_NAME: '@itemTransformation',
    OMIT_SOURCE_PROPERTY_NAME: '@source',
    FIELDS_TO_OMIT_PROPERTY_NAME: '@omit',
    SPREAD_OPERATOR: '*',
    CONSTANT_VALUE_PROPERTY_NAME: '@constant',
};
export { transformations, unwrap };
//# sourceMappingURL=common.js.map